import { createAxios } from "./axiosHttpMarconi";
export const partnerService = {
  getOficinas,
  partnerSolucion,
  getAllPartners,
  getPartnerByCode,
  getPartners,
  updatePartner,
};

function getOficinas(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/partners/oficinas`;
  if (filters && filters.codigoPostal) {
    urlPath += `?codigoPostal=${filters.codigoPostal}`;
  }
  if (filters && filters.poblacion) {
    urlPath += `&poblacion=${filters.poblacion}`;
  }
  if (filters && filters.idioma) {
    urlPath += `&idioma=${filters.idioma}`;
  }
  return axios.get(urlPath);
}
function partnerSolucion(idIncidencia, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/partners/incidencia/${idIncidencia}`;
  return axios.post(urlPath, body);
}

function getAllPartners() {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/partners/all`;
  return axios.get(urlPath);
}

function getPartnerByCode(code) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/partners/${code}`;
  return axios.get(urlPath);
}

function getPartners(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/partners`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  return axios.get(urlPath);
}

function updatePartner(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/partners/${id}`;
  return axios.put(urlPath, body);
}
